import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeDetectorRef, Component, Injector, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Asegurado } from 'src/app/Models/asegurado-detalle';
import { Seguro } from 'src/app/Models/seguro';
import { AppInsightsService } from 'src/app/Services/appInsight.service';
import { FormDataService } from 'src/app/Services/form-data.services';
import { ApiService } from '../../Services/api.services';
import { NuevaVistaComponent } from 'src/app/MisEventos/nueva-vista/nueva-vista.component';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-seguro',
  templateUrl: './seguro.component.html',
  styleUrls: ['./seguro.component.css']
})
export class SeguroComponent implements OnInit {
  asegurado: Asegurado;
  patente: string;
  seguro: Seguro = new Seguro();
  loader: boolean;

  constructor(
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private inj: Injector,
    private modal:NgbModal
  ) {
  }


  ngOnInit(): void {
    this.asegurado = JSON.parse(localStorage.getItem('asegurado'));

    const appInsightService = this.inj.get(AppInsightsService);
    appInsightService.setUserId(this.asegurado.Rut);

    this.activatedRoute.params.subscribe(params => {
      this.loader = true;
      if (params['poliza'] !== undefined) {
        this.obtainDataMiSeguro(this.asegurado.Rut, params['poliza']);
       }
      else { 
        if (environment.showmodal=='true') {
          this.modal.open(NuevaVistaComponent, {
            ariaLabelledBy: 'modalCotizacion',
            backdropClass: 'in',
          });
        }

        if (localStorage.getItem('firstInsurancePolicy') !== null) {
          if (localStorage.getItem('miSeguro') == null){
            this.obtainDataMiSeguro(this.asegurado.Rut, localStorage.getItem('firstInsurancePolicy'));
         }
          else{
            this.setDataMiSeguro(JSON.parse(localStorage.getItem('miSeguro')));
            this.loader = false;
            }
        }
      }
    });
  }

  private setDataMiSeguro(response: any): void{
    let fechaHoy = new Date();
    this.seguro.poliza = response.poliza;
    this.seguro.facturacion = response.facturacion;
    this.seguro.mesAnterior = response.mesAnterior;
    this.seguro.seisMeses = response.seisMeses;
    this.seguro.asistencias = response.asistencias;
    this.seguro.ultimaUbicacion = response.ultimaUbicacion;
    localStorage.setItem('miSeguro', JSON.stringify(this.seguro));
    const appInsightService = this.inj.get(AppInsightsService);
    appInsightService.logEvent(`Datos generales inicio sesion ( rut: ${this.asegurado.Rut}, Nombres y apellidos: ${this.asegurado.Nombre}, patente: , Marca: ${this.seguro.poliza.marca}, Modelo: ${this.seguro.poliza.modelo}, año: ${this.seguro.poliza.anno}, Deducible: ${this.seguro.poliza.deducible}, Viaje activicacion: , fecha: ${fechaHoy} )`);
  }

  public obtainDataMiSeguro(rut: string, idPoliza: string): void{
    this.apiService.getMiSeguro(rut, idPoliza).subscribe((response: any) => {
      this.setDataMiSeguro(response);
      this.loader = false;
    },
    error => {
      const appInsightService = this.inj.get(AppInsightsService);
      appInsightService.logException(error);
      this.handleOfferErrorTechniques(error);
    });
  }

  public handleOfferErrorTechniques(error: any): void {
    console.log('no offer for you, sorry', error);
    this.router.navigate(['/errortechniques']);
  }
}
